/**
 * 管理所有需要存储的StorageKey
 */
enum StorageKeys {
  'Bread' = 'Bread',
}

export default StorageKeys;
